import { compact, filter, includes, uniq } from '@quromedical/utils';

/**
 * Get a unique list of all duplicates in an array
 * @param arr
 * @returns
 */
export const getDuplicates = <T = string | number>(arr: Array<T>): Array<T> => {
  const duplicates = filter(arr, (val, i, itt) => includes(itt, val, i + 1));

  return uniq(duplicates);
};

/**
 * Get a compacted array with duplicates and `undefined` removed
 */
export const removeDuplicates = <T = string | number>(
  arr: Array<T>,
): Array<T> => {
  const unique = uniq(arr);
  return compact(unique);
};
